import { render, staticRenderFns } from "./ContentReviewStatusLabel.vue?vue&type=template&id=0a41e9b6"
import script from "./ContentReviewStatusLabel.vue?vue&type=script&lang=ts"
export * from "./ContentReviewStatusLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports